import { FC } from "react";
import PrepState25Svg from "../../public/icons/PrepState25.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const GeometryBuildUpPrepState25Icon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><PrepState25Svg/></span>;
